import client from "../apolloClient";
import { GET_SALON_BY_ID } from "../queries/salon.queries";

export const getSalonById = async (id: string) => {
    try {
      console.log('Fetching salon with ID:', id);
      
      const { data, error } = await client.query({
        query: GET_SALON_BY_ID,
        variables: { id },
      });

      if (error) {
        console.error('Error fetching salon:', error);
        throw error;
      }

      return data.getSalonById;
    } catch (error: any) {
      console.error('Error fetching salon:', {
        error: error.message,
        networkError: error.networkError?.message,
        graphQLErrors: error.graphQLErrors,
      });
    }
  }